import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../context/AuthContext";
import PerfectScrollbar from "react-perfect-scrollbar";

import {
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledButtonDropdown,
} from "reactstrap";

import {
  faAngleDown,
  faUser,
  faSignOutAlt,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

// import avatar1 from "../../../assets/utils/images/avatars/1.jpg"; // Removed avatar image

const UserBox = () => {
  const { user, logout, isAdmin } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  if (!user) {
    return null;
  }

  return (
    <div className="header-btn-lg pe-0">
      <div className="widget-content p-0">
        <div className="widget-content-wrapper">
          <div className="widget-content-left">
            <UncontrolledButtonDropdown>
              <DropdownToggle color="link" className="p-0">
                <div className="d-flex align-items-center">
                  <div
                    style={{
                      width: "42px",
                      height: "42px",
                      backgroundColor: "#e9ecef",
                      borderRadius: "50%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <FontAwesomeIcon
                      icon={faUser}
                      style={{ fontSize: "20px", color: "#6c757d" }}
                    />
                  </div>
                  <FontAwesomeIcon
                    className="ms-2 opacity-8"
                    icon={faAngleDown}
                  />
                </div>
              </DropdownToggle>
              <DropdownMenu end className="rm-pointers dropdown-menu-lg">
                <div className="dropdown-menu-header">
                  <div className="dropdown-menu-header-inner bg-info">
                    <div className="menu-header-content text-start">
                      <div className="widget-content p-0">
                        <div className="widget-content-wrapper">
                          <div className="widget-content-left me-3">
                            <div
                              style={{
                                width: "42px",
                                height: "42px",
                                backgroundColor: "rgba(255,255,255,0.2)",
                                borderRadius: "50%",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              <FontAwesomeIcon
                                icon={faUser}
                                style={{ fontSize: "20px", color: "white" }}
                              />
                            </div>
                          </div>
                          <div className="widget-content-left">
                            <div className="widget-heading text-white">
                              {user.fullName || user.username || "User"}
                            </div>
                            <div className="widget-subheading opacity-8 text-white">
                              {user.email || ""}
                            </div>
                            <div className="widget-subheading opacity-8 text-white">
                              Role: {user.role || "user"}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="scroll-area-xs">
                  <PerfectScrollbar>
                    <div className="p-3">
                      {isAdmin() && (
                        <DropdownItem
                          onClick={() => navigate("/admin/users")}
                          className="d-flex align-items-center"
                        >
                          <FontAwesomeIcon icon={faUser} className="me-2" />
                          User Management
                        </DropdownItem>
                      )}
                      <div className="dropdown-divider"></div>
                      <DropdownItem
                        onClick={handleLogout}
                        className="d-flex align-items-center text-danger"
                      >
                        <FontAwesomeIcon icon={faSignOutAlt} className="me-2" />
                        Logout
                      </DropdownItem>
                    </div>
                  </PerfectScrollbar>
                </div>
              </DropdownMenu>
            </UncontrolledButtonDropdown>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserBox;
